module.exports = __webpack_public_path__ + "img/6_129.6863e8de.png";